// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const BriefcaseIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1875 26V6.44444C19.1875 5.09442 18.1382 4 16.8438 4H12.1562C10.8618 4 9.8125 5.09442 9.8125 6.44444V26M4 25.9999H25C26.1046 25.9999 27 25.1045 27 23.9999V10.7142C27 9.60966 26.1046 8.71423 25 8.71423H4C2.89543 8.71423 2 9.60966 2 10.7142V23.9999C2 25.1045 2.89543 25.9999 4 25.9999Z"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BriefcaseIcon;
